module.exports = __webpack_public_path__ + "img/blogs_layout6.c94d33bf.png";